define('Components/IconWidget/js/models/IconWidgetInstanceModel',['underscore', 'backbone', 'WidgetInstanceModel', 'app', 'ObjectModel', 'ObjectCollection', 'moment'], function (_, Backbone, WidgetInstanceModel, app, ObjectModel, ObjectCollection,

moment
) {
    var DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss ZZ';
    var AdvantageModel = ObjectModel.extend({

        route: 'apiAdvantageModel',


    });


    return WidgetInstanceModel.extend({

        getIcon:function () {
            return this.p('icon');
        },


    })
});
